module.exports = __webpack_public_path__ + "img/Weapon_290.aa5babc7.png";